import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { SimilarProductsRecoSlider } from '@packages/recommendations';
import { Typography } from '@packages/shared';
import { useIntl } from 'react-intl';
import { SlotBox } from '../SlotBox';
import { messages } from './messages';

export const SimilarRecoFragment = graphql(/* GraphQL */ `
  fragment SimilarRecoFragment on Product {
    hasSeries
    promotion
    orderNumber
  }
`);

export type SimilarProductsProps = {
  data: FragmentType<typeof SimilarRecoFragment>;
};

export const SimilarProducts = ({ data }: SimilarProductsProps) => {
  const { hasSeries, orderNumber, promotion } = getFragmentData(SimilarRecoFragment, data);
  const { formatMessage } = useIntl();

  return (
    <>
      <Typography variant="h2" component="header" sx={{ m: 2 }}>
        {formatMessage(messages.headline)}
      </Typography>
      <SlotBox>
        <SimilarProductsRecoSlider
          productId={`${orderNumber}${promotion}`}
          elementIndex={hasSeries ? 3 : 2}
          fetchOnThreshold
          pageTemplate="detailview"
          title={formatMessage(messages.title)}
          key={`${orderNumber}${3}`}
        />
      </SlotBox>
    </>
  );
};
